<div class="rte">
  <div class="rte-toolbar" (mousedown)="$event.preventDefault()">
    <button type="button" mat-icon-button matTooltip="Bold" (click)="exec('bold')">
      <mat-icon>format_bold</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Italic" (click)="exec('italic')">
      <mat-icon>format_italic</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Underline" (click)="exec('underline')">
      <mat-icon>format_underlined</mat-icon>
    </button>
    <span class="rte-divider"></span>
    <button type="button" mat-icon-button matTooltip="Bulleted list" (click)="exec('insertUnorderedList')">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Numbered list" (click)="exec('insertOrderedList')">
      <mat-icon>format_list_numbered</mat-icon>
    </button>
    <span class="rte-divider"></span>
    <button type="button" mat-icon-button matTooltip="Insert link" (click)="insertLink()">
      <mat-icon>link</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Remove formatting" (click)="exec('removeFormat')">
      <mat-icon>format_clear</mat-icon>
    </button>
  </div>
  <div
    #editor
    class="rte-content"
    [attr.contenteditable]="!disabled"
    [attr.data-placeholder]="placeholder"
    [style.min-height]="minHeight"
    (input)="onInput()"
    (blur)="onBlur()"
  ></div>
</div>
